const config = {
    API_URL: process.env.REACT_APP_API_URL,
    isDevelopment: process.env.NODE_ENV === 'development',
};
export default config;
